module.exports = __webpack_public_path__ + "img/logo.cb3ef2f9.png";